import { Tag } from '@limepayments/cosmic';
import { TagProps } from '@limepayments/cosmic/build/Tag/Tag';

export interface StatusTagProps {
  label: string;
  variant: TagProps['variant'];
  tooltipText: string;
  tooltipDirection: any;
}

function StatusTag({ label, variant, tooltipText, tooltipDirection }: StatusTagProps) {
  return (
    <div
      className="lp-flex"
      data-balloon={tooltipText}
      data-balloon-pos={tooltipDirection}
      data-balloon-mobile-pos="left"
      data-balloon-length="large"
      data-balloon-mobile-length="medium"
    >
      <Tag label={label} size="small" variant={variant} />
    </div>
  );
}

export default StatusTag;
